import Papa from 'papaparse';
import io from 'socket.io-client';
import { useState, useEffect } from 'react';

export const handleFileUpload = async (dataBlob, serverBaseUrl) => {
    try {
        const formData = new FormData();
        formData.append('file', dataBlob, 'data.csv');

        const response = await fetch(`${serverBaseUrl}/upload`, {
            method: 'POST',
            body: formData,
        });

        return response;
    } catch (error) {
        console.error('Error uploading file:', error);
        throw error; // Rethrow the error for handling in App.js
    }
};

export const parseCSV = (contents) => {
    return new Promise((resolve, reject) => {
        Papa.parse(contents, {
            header: true,
            complete: (results) => resolve(results.data),
            error: (error) => {
                console.error('Error parsing CSV:', error);
                reject(error);
            }
        });
    });
};


export const convertFileViaSocket = (socket, file, onProgress) => {
    return new Promise((resolve, reject) => {
        // Convert file to Base64
        const reader = new FileReader();
        reader.onload = () => {
            // Remove the data URL header if present
            let fileData = reader.result;
            if (fileData.startsWith("data:")) {
                fileData = fileData.substring(fileData.indexOf(",") + 1);
            }

            // Emit the file conversion event
            socket.emit("convert_file", { file_data: fileData, file_name: file.name });

            const progressHandler = (data) => {
                console.log(data);
                if (data.message) {
                    if (onProgress) onProgress(data.message);
                }
            };

            const completeHandler = (data) => {
                cleanup();
                if (data.locations && Array.isArray(data.locations)) {
                    resolve({ type: 'complete', locations: data.locations });
                } else {
                    reject(new Error("Unexpected data format"));
                }
            };

            const errorHandler = (data) => {
                cleanup();
                reject(new Error(data.error));
            };

            const cleanup = () => {
                socket.off("progress", progressHandler);
                socket.off("complete", completeHandler);
                socket.off("error", errorHandler);
            };

            socket.on("progress", progressHandler);
            socket.on("complete", completeHandler);
            socket.on("error", errorHandler);
        };

        reader.onerror = (error) => {
            reject(error);
        };

        reader.readAsDataURL(file);
    });
};

export const useSocket = () => {
    const [socket, setSocket] = useState(null);

    useEffect(() => {
        if (!process.env.REACT_APP_SERVER_URL) {
            throw new Error('Server URL not configured. Please set REACT_APP_SERVER_URL in .env');
        }

        const newSocket = io(process.env.REACT_APP_SERVER_URL);
        setSocket(newSocket);

        return () => {
            if (newSocket) newSocket.close();
        };
    }, []);

    return socket;
};


export const convertToGeoJSON = (data) => {
    console.log("Convert to GeoJSON");
    try {
        // Ensure input data is an array
        if (!Array.isArray(data)) {
            throw new Error("Input data is not an array");
        }

        const geojson = {
            type: "FeatureCollection",
            features: data
                .filter((item) => {
                    // Validate necessary fields and skip invalid rows
                    if (
                        !item ||
                        typeof item.Long === "undefined" ||
                        typeof item.Lat === "undefined" ||
                        isNaN(parseFloat(item.Long)) ||
                        isNaN(parseFloat(item.Lat))
                    ) {
                        console.warn("Skipping row with missing or invalid coordinates:", item);
                        return false;
                    }
                    return true;
                })
                .map((item) => {
                    return {
                        type: "Feature",
                        geometry: {
                            type: "Point",
                            coordinates: [parseFloat(item.Long), parseFloat(item.Lat)],
                        },
                        properties: {
                            Category: item.Category || null,
                            Title: item.Title || null,
                            Subtitle: item.Address || null,
                            Description: item.Description || null,
                            Id: item.Id || null,
                        },
                    };
                }),
        };

        return geojson;
    } catch (error) {
        console.error("Error converting data to GeoJSON:", error.message);
        // Return an empty GeoJSON object on any failure
        return {
            type: "FeatureCollection",
            features: [],
        };
    }
};